import {Box, Typography} from '@mui/material';

interface Props {
  title: string;
  text: string;
  color: string;
  testId?: string;
}

export const InfoBox = ({title, text, color, testId}: Props) => (
  <Box paddingBottom='16px'>
    <Typography variant='h4'>{title}</Typography>
    <Typography data-testid={testId || `${title}-${text}`} sx={{whiteSpace: 'pre-line'}} variant='body1' color={color}>
      {text}
    </Typography>
  </Box>
);
